/* eslint-disable */
!(function(e, t) {
    if (!e) return (module.exports = {});

    'object' == typeof exports && 'object' == typeof module
        ? (module.exports = t(require('react'), require('react-dom')))
        : 'function' == typeof define && define.amd
            ? define(['react', 'react-dom'], t)
            : 'object' == typeof exports
                ? (exports.Slider = t(require('react'), require('react-dom')))
                : (e.Slider = t(e.React, e.ReactDOM));
})(typeof window === 'undefined' ? undefined : window, function(e, t) {
    return (
        (i = {}),
        (n.m = r = [
            function(t, n) {
                t.exports = e;
            },
            function(e, t, n) {
                var r;
                /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
                /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ !(function() {
                    'use strict';
                    var n = {}.hasOwnProperty;
                    function i() {
                        for (var e = [], t = 0; t < arguments.length; t++) {
                            var r = arguments[t];
                            if (r) {
                                var o = typeof r;
                                if ('string' == o || 'number' == o) e.push(r);
                                else if (Array.isArray(r) && r.length) {
                                    var s = i.apply(null, r);
                                    s && e.push(s);
                                } else if ('object' == o) for (var a in r) n.call(r, a) && r[a] && e.push(a);
                            }
                        }
                        return e.join(' ');
                    }
                    e.exports
                        ? ((i.default = i), (e.exports = i))
                        : void 0 ===
                              (r = function() {
                                  return i;
                              }.apply(t, [])) || (e.exports = r);
                })();
            },
            function(e, n) {
                e.exports = t;
            },
            function(e, t, n) {
                function r(e) {
                    var t = '',
                        n = Object.keys(e);
                    return (
                        n.forEach(function(r, o) {
                            var s = e[r];
                            !(function(e) {
                                return /[height|width]$/.test(e);
                            })((r = i(r))) ||
                                'number' != typeof s ||
                                (s += 'px'),
                                (t += !0 === s ? r : !1 === s ? 'not ' + r : '(' + r + ': ' + s + ')'),
                                o < n.length - 1 && (t += ' and ');
                        }),
                        t
                    );
                }
                var i = n(8);
                e.exports = function(e) {
                    var t = '';
                    return 'string' == typeof e
                        ? e
                        : e instanceof Array
                            ? (e.forEach(function(n, i) {
                                  (t += r(n)), i < e.length - 1 && (t += ', ');
                              }),
                              t)
                            : r(e);
                };
            },
            function(e, t) {
                var n;
                n = (function() {
                    return this;
                })();
                try {
                    n = n || new Function('return this')();
                } catch (e) {
                    'object' == typeof window && (n = window);
                }
                e.exports = n;
            },
            function(e, t) {
                e.exports = {
                    isFunction: function(e) {
                        return 'function' == typeof e;
                    },
                    isArray: function(e) {
                        return '[object Array]' === Object.prototype.toString.apply(e);
                    },
                    each: function(e, t) {
                        for (var n = 0, r = e.length; n < r && !1 !== t(e[n], n); n++);
                    },
                };
            },
            function(e, t, n) {
                (function(t) {
                    function n() {
                        return p.Date.now();
                    }
                    var r = NaN,
                        i = '[object Symbol]',
                        o = /^\s+|\s+$/g,
                        s = /^[-+]0x[0-9a-f]+$/i,
                        a = /^0b[01]+$/i,
                        l = /^0o[0-7]+$/i,
                        c = parseInt,
                        u = 'object' == typeof t && t && t.Object === Object && t,
                        d = 'object' == typeof self && self && self.Object === Object && self,
                        p = u || d || Function('return this')(),
                        f = Object.prototype.toString,
                        h = Math.max,
                        y = Math.min;
                    function v(e) {
                        var t = typeof e;
                        return !!e && ('object' == t || 'function' == t);
                    }
                    function b(e) {
                        if ('number' == typeof e) return e;
                        if (
                            (function(e) {
                                return (
                                    'symbol' == typeof e ||
                                    ((function(e) {
                                        return !!e && 'object' == typeof e;
                                    })(e) &&
                                        f.call(e) == i)
                                );
                            })(e)
                        )
                            return r;
                        if (v(e)) {
                            var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
                            e = v(t) ? t + '' : t;
                        }
                        if ('string' != typeof e) return 0 === e ? e : +e;
                        e = e.replace(o, '');
                        var n = a.test(e);
                        return n || l.test(e) ? c(e.slice(2), n ? 2 : 8) : s.test(e) ? r : +e;
                    }
                    e.exports = function(e, t, r) {
                        var i,
                            o,
                            s,
                            a,
                            l,
                            c,
                            u = 0,
                            d = !1,
                            p = !1,
                            f = !0;
                        if ('function' != typeof e) throw new TypeError('Expected a function');
                        function g(t) {
                            var n = i,
                                r = o;
                            return (i = o = void 0), (u = t), (a = e.apply(r, n));
                        }
                        function m(e) {
                            var n = e - c;
                            return void 0 === c || t <= n || n < 0 || (p && s <= e - u);
                        }
                        function w() {
                            var e = n();
                            if (m(e)) return S(e);
                            l = setTimeout(
                                w,
                                (function(e) {
                                    var n = t - (e - c);
                                    return p ? y(n, s - (e - u)) : n;
                                })(e),
                            );
                        }
                        function S(e) {
                            return (l = void 0), f && i ? g(e) : ((i = o = void 0), a);
                        }
                        function O() {
                            var e = n(),
                                r = m(e);
                            if (((i = arguments), (o = this), (c = e), r)) {
                                if (void 0 === l)
                                    return (function(e) {
                                        return (u = e), (l = setTimeout(w, t)), d ? g(e) : a;
                                    })(c);
                                if (p) return (l = setTimeout(w, t)), g(c);
                            }
                            return void 0 === l && (l = setTimeout(w, t)), a;
                        }
                        return (
                            (t = b(t) || 0),
                            v(r) &&
                                ((d = !!r.leading),
                                (s = (p = 'maxWait' in r) ? h(b(r.maxWait) || 0, t) : s),
                                (f = 'trailing' in r ? !!r.trailing : f)),
                            (O.cancel = function() {
                                void 0 !== l && clearTimeout(l), (i = c = o = l = void (u = 0));
                            }),
                            (O.flush = function() {
                                return void 0 === l ? a : S(n());
                            }),
                            O
                        );
                    };
                }.call(this, n(4)));
            },
            function(e, t, n) {
                'use strict';
                (function(e) {
                    var n = (function() {
                            if ('undefined' != typeof Map) return Map;
                            function e(e, t) {
                                var n = -1;
                                return (
                                    e.some(function(e, r) {
                                        return e[0] === t && ((n = r), !0);
                                    }),
                                    n
                                );
                            }
                            return (
                                Object.defineProperty(t.prototype, 'size', {
                                    get: function() {
                                        return this.__entries__.length;
                                    },
                                    enumerable: !0,
                                    configurable: !0,
                                }),
                                (t.prototype.get = function(t) {
                                    var n = e(this.__entries__, t),
                                        r = this.__entries__[n];
                                    return r && r[1];
                                }),
                                (t.prototype.set = function(t, n) {
                                    var r = e(this.__entries__, t);
                                    ~r ? (this.__entries__[r][1] = n) : this.__entries__.push([t, n]);
                                }),
                                (t.prototype.delete = function(t) {
                                    var n = this.__entries__,
                                        r = e(n, t);
                                    ~r && n.splice(r, 1);
                                }),
                                (t.prototype.has = function(t) {
                                    return !!~e(this.__entries__, t);
                                }),
                                (t.prototype.clear = function() {
                                    this.__entries__.splice(0);
                                }),
                                (t.prototype.forEach = function(e, t) {
                                    void 0 === t && (t = null);
                                    for (var n = 0, r = this.__entries__; n < r.length; n++) {
                                        var i = r[n];
                                        e.call(t, i[1], i[0]);
                                    }
                                }),
                                t
                            );
                            function t() {
                                this.__entries__ = [];
                            }
                        })(),
                        r =
                            'undefined' != typeof window &&
                            'undefined' != typeof document &&
                            window.document === document,
                        i =
                            void 0 !== e && e.Math === Math
                                ? e
                                : 'undefined' != typeof self && self.Math === Math
                                    ? self
                                    : 'undefined' != typeof window && window.Math === Math
                                        ? window
                                        : Function('return this')(),
                        o =
                            'function' == typeof requestAnimationFrame
                                ? requestAnimationFrame.bind(i)
                                : function(e) {
                                      return setTimeout(function() {
                                          return e(Date.now());
                                      }, 1e3 / 60);
                                  },
                        s = 2,
                        a = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'],
                        l = 'undefined' != typeof MutationObserver,
                        c = ((u.prototype.addObserver = function(e) {
                            ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
                        }),
                        (u.prototype.removeObserver = function(e) {
                            var t = this.observers_,
                                n = t.indexOf(e);
                            ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_();
                        }),
                        (u.prototype.refresh = function() {
                            this.updateObservers_() && this.refresh();
                        }),
                        (u.prototype.updateObservers_ = function() {
                            var e = this.observers_.filter(function(e) {
                                return e.gatherActive(), e.hasActive();
                            });
                            return (
                                e.forEach(function(e) {
                                    return e.broadcastActive();
                                }),
                                0 < e.length
                            );
                        }),
                        (u.prototype.connect_ = function() {
                            r &&
                                !this.connected_ &&
                                (document.addEventListener('transitionend', this.onTransitionEnd_),
                                window.addEventListener('resize', this.refresh),
                                l
                                    ? ((this.mutationsObserver_ = new MutationObserver(this.refresh)),
                                      this.mutationsObserver_.observe(document, {
                                          attributes: !0,
                                          childList: !0,
                                          characterData: !0,
                                          subtree: !0,
                                      }))
                                    : (document.addEventListener('DOMSubtreeModified', this.refresh),
                                      (this.mutationEventsAdded_ = !0)),
                                (this.connected_ = !0));
                        }),
                        (u.prototype.disconnect_ = function() {
                            r &&
                                this.connected_ &&
                                (document.removeEventListener('transitionend', this.onTransitionEnd_),
                                window.removeEventListener('resize', this.refresh),
                                this.mutationsObserver_ && this.mutationsObserver_.disconnect(),
                                this.mutationEventsAdded_ &&
                                    document.removeEventListener('DOMSubtreeModified', this.refresh),
                                (this.mutationsObserver_ = null),
                                (this.mutationEventsAdded_ = !1),
                                (this.connected_ = !1));
                        }),
                        (u.prototype.onTransitionEnd_ = function(e) {
                            var t = e.propertyName,
                                n = void 0 === t ? '' : t;
                            a.some(function(e) {
                                return !!~n.indexOf(e);
                            }) && this.refresh();
                        }),
                        (u.getInstance = function() {
                            return this.instance_ || (this.instance_ = new u()), this.instance_;
                        }),
                        (u.instance_ = null),
                        u);
                    function u() {
                        (this.connected_ = !1),
                            (this.mutationEventsAdded_ = !1),
                            (this.mutationsObserver_ = null),
                            (this.observers_ = []),
                            (this.onTransitionEnd_ = this.onTransitionEnd_.bind(this)),
                            (this.refresh = (function(e, t) {
                                var n = !1,
                                    r = !1,
                                    i = 0;
                                function a() {
                                    n && ((n = !1), e()), r && c();
                                }
                                function l() {
                                    o(a);
                                }
                                function c() {
                                    var e = Date.now();
                                    if (n) {
                                        if (e - i < s) return;
                                        r = !0;
                                    } else (r = !(n = !0)), setTimeout(l, t);
                                    i = e;
                                }
                                return c;
                            })(this.refresh.bind(this), 20));
                    }
                    var d = function(e, t) {
                            for (var n = 0, r = Object.keys(t); n < r.length; n++) {
                                var i = r[n];
                                Object.defineProperty(e, i, {
                                    value: t[i],
                                    enumerable: !1,
                                    writable: !1,
                                    configurable: !0,
                                });
                            }
                            return e;
                        },
                        p = function(e) {
                            return (e && e.ownerDocument && e.ownerDocument.defaultView) || i;
                        },
                        f = g(0, 0, 0, 0);
                    function h(e) {
                        return parseFloat(e) || 0;
                    }
                    function y(e) {
                        for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
                        return t.reduce(function(t, n) {
                            return t + h(e['border-' + n + '-width']);
                        }, 0);
                    }
                    var v =
                        'undefined' != typeof SVGGraphicsElement
                            ? function(e) {
                                  return e instanceof p(e).SVGGraphicsElement;
                              }
                            : function(e) {
                                  return e instanceof p(e).SVGElement && 'function' == typeof e.getBBox;
                              };
                    function b(e) {
                        return r
                            ? v(e)
                                ? (function(e) {
                                      var t = e.getBBox();
                                      return g(0, 0, t.width, t.height);
                                  })(e)
                                : (function(e) {
                                      var t = e.clientWidth,
                                          n = e.clientHeight;
                                      if (!t && !n) return f;
                                      var r = p(e).getComputedStyle(e),
                                          i = (function(e) {
                                              for (
                                                  var t = {}, n = 0, r = ['top', 'right', 'bottom', 'left'];
                                                  n < r.length;
                                                  n++
                                              ) {
                                                  var i = r[n],
                                                      o = e['padding-' + i];
                                                  t[i] = h(o);
                                              }
                                              return t;
                                          })(r),
                                          o = i.left + i.right,
                                          s = i.top + i.bottom,
                                          a = h(r.width),
                                          l = h(r.height);
                                      if (
                                          ('border-box' === r.boxSizing &&
                                              (Math.round(a + o) !== t && (a -= y(r, 'left', 'right') + o),
                                              Math.round(l + s) !== n && (l -= y(r, 'top', 'bottom') + s)),
                                          !(function(e) {
                                              return e === p(e).document.documentElement;
                                          })(e))
                                      ) {
                                          var c = Math.round(a + o) - t,
                                              u = Math.round(l + s) - n;
                                          1 !== Math.abs(c) && (a -= c), 1 !== Math.abs(u) && (l -= u);
                                      }
                                      return g(i.left, i.top, a, l);
                                  })(e)
                            : f;
                    }
                    function g(e, t, n, r) {
                        return { x: e, y: t, width: n, height: r };
                    }
                    var m = ((w.prototype.isActive = function() {
                        var e = b(this.target);
                        return (
                            (this.contentRect_ = e).width !== this.broadcastWidth || e.height !== this.broadcastHeight
                        );
                    }),
                    (w.prototype.broadcastRect = function() {
                        var e = this.contentRect_;
                        return (this.broadcastWidth = e.width), (this.broadcastHeight = e.height), e;
                    }),
                    w);
                    function w(e) {
                        (this.broadcastWidth = 0),
                            (this.broadcastHeight = 0),
                            (this.contentRect_ = g(0, 0, 0, 0)),
                            (this.target = e);
                    }
                    var S = function(e, t) {
                            var n = (function(e) {
                                var t = e.x,
                                    n = e.y,
                                    r = e.width,
                                    i = e.height,
                                    o = 'undefined' != typeof DOMRectReadOnly ? DOMRectReadOnly : Object,
                                    s = Object.create(o.prototype);
                                return (
                                    d(s, {
                                        x: t,
                                        y: n,
                                        width: r,
                                        height: i,
                                        top: n,
                                        right: t + r,
                                        bottom: i + n,
                                        left: t,
                                    }),
                                    s
                                );
                            })(t);
                            d(this, { target: e, contentRect: n });
                        },
                        O = ((k.prototype.observe = function(e) {
                            if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
                            if ('undefined' != typeof Element && Element instanceof Object) {
                                if (!(e instanceof p(e).Element))
                                    throw new TypeError('parameter 1 is not of type "Element".');
                                var t = this.observations_;
                                t.has(e) ||
                                    (t.set(e, new m(e)),
                                    this.controller_.addObserver(this),
                                    this.controller_.refresh());
                            }
                        }),
                        (k.prototype.unobserve = function(e) {
                            if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
                            if ('undefined' != typeof Element && Element instanceof Object) {
                                if (!(e instanceof p(e).Element))
                                    throw new TypeError('parameter 1 is not of type "Element".');
                                var t = this.observations_;
                                t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
                            }
                        }),
                        (k.prototype.disconnect = function() {
                            this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
                        }),
                        (k.prototype.gatherActive = function() {
                            var e = this;
                            this.clearActive(),
                                this.observations_.forEach(function(t) {
                                    t.isActive() && e.activeObservations_.push(t);
                                });
                        }),
                        (k.prototype.broadcastActive = function() {
                            if (this.hasActive()) {
                                var e = this.callbackCtx_,
                                    t = this.activeObservations_.map(function(e) {
                                        return new S(e.target, e.broadcastRect());
                                    });
                                this.callback_.call(e, t, e), this.clearActive();
                            }
                        }),
                        (k.prototype.clearActive = function() {
                            this.activeObservations_.splice(0);
                        }),
                        (k.prototype.hasActive = function() {
                            return 0 < this.activeObservations_.length;
                        }),
                        k);
                    function k(e, t, r) {
                        if (((this.activeObservations_ = []), (this.observations_ = new n()), 'function' != typeof e))
                            throw new TypeError('The callback provided as parameter 1 is not a function.');
                        (this.callback_ = e), (this.controller_ = t), (this.callbackCtx_ = r);
                    }
                    var T = 'undefined' != typeof WeakMap ? new WeakMap() : new n(),
                        E = function e(t) {
                            if (!(this instanceof e)) throw new TypeError('Cannot call a class as a function.');
                            if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
                            var n = c.getInstance(),
                                r = new O(t, n, this);
                            T.set(this, r);
                        };
                    ['observe', 'unobserve', 'disconnect'].forEach(function(e) {
                        E.prototype[e] = function() {
                            var t;
                            return (t = T.get(this))[e].apply(t, arguments);
                        };
                    });
                    var _ = void 0 !== i.ResizeObserver ? i.ResizeObserver : E;
                    t.a = _;
                }.call(this, n(4)));
            },
            function(e, t) {
                e.exports = function(e) {
                    return e
                        .replace(/[A-Z]/g, function(e) {
                            return '-' + e.toLowerCase();
                        })
                        .toLowerCase();
                };
            },
            function(e, t, n) {
                var r = n(10);
                e.exports = new r();
            },
            function(e, t, n) {
                var r = n(11),
                    i = n(5),
                    o = i.each,
                    s = i.isFunction,
                    a = i.isArray;
                function l() {
                    if (!window.matchMedia)
                        throw new Error('matchMedia not present, legacy browsers require a polyfill');
                    (this.queries = {}), (this.browserIsIncapable = !window.matchMedia('only all').matches);
                }
                (l.prototype = {
                    constructor: l,
                    register: function(e, t, n) {
                        var i = this.queries,
                            l = n && this.browserIsIncapable;
                        return (
                            i[e] || (i[e] = new r(e, l)),
                            s(t) && (t = { match: t }),
                            a(t) || (t = [t]),
                            o(t, function(t) {
                                s(t) && (t = { match: t }), i[e].addHandler(t);
                            }),
                            this
                        );
                    },
                    unregister: function(e, t) {
                        var n = this.queries[e];
                        return n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])), this;
                    },
                }),
                    (e.exports = l);
            },
            function(e, t, n) {
                var r = n(12),
                    i = n(5).each;
                function o(e, t) {
                    (this.query = e),
                        (this.isUnconditional = t),
                        (this.handlers = []),
                        (this.mql = window.matchMedia(e));
                    var n = this;
                    (this.listener = function(e) {
                        (n.mql = e.currentTarget || e), n.assess();
                    }),
                        this.mql.addListener(this.listener);
                }
                (o.prototype = {
                    constuctor: o,
                    addHandler: function(e) {
                        var t = new r(e);
                        this.handlers.push(t), this.matches() && t.on();
                    },
                    removeHandler: function(e) {
                        var t = this.handlers;
                        i(t, function(n, r) {
                            if (n.equals(e)) return n.destroy(), !t.splice(r, 1);
                        });
                    },
                    matches: function() {
                        return this.mql.matches || this.isUnconditional;
                    },
                    clear: function() {
                        i(this.handlers, function(e) {
                            e.destroy();
                        }),
                            this.mql.removeListener(this.listener),
                            (this.handlers.length = 0);
                    },
                    assess: function() {
                        var e = this.matches() ? 'on' : 'off';
                        i(this.handlers, function(t) {
                            t[e]();
                        });
                    },
                }),
                    (e.exports = o);
            },
            function(e, t) {
                function n(e) {
                    (this.options = e).deferSetup || this.setup();
                }
                (n.prototype = {
                    constructor: n,
                    setup: function() {
                        this.options.setup && this.options.setup(), (this.initialised = !0);
                    },
                    on: function() {
                        this.initialised || this.setup(), this.options.match && this.options.match();
                    },
                    off: function() {
                        this.options.unmatch && this.options.unmatch();
                    },
                    destroy: function() {
                        this.options.destroy ? this.options.destroy() : this.off();
                    },
                    equals: function(e) {
                        return this.options === e || this.options.match === e;
                    },
                }),
                    (e.exports = n);
            },
            function(e, t, n) {
                'use strict';
                n.r(t);
                var r = n(0),
                    i = n.n(r),
                    o = n(2),
                    s = n.n(o),
                    a = {
                        animating: !1,
                        autoplaying: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        dragging: !1,
                        edgeDragged: !1,
                        initialized: !1,
                        lazyLoadedList: [],
                        listHeight: null,
                        listWidth: null,
                        scrolling: !1,
                        slideCount: null,
                        slideHeight: null,
                        slideWidth: null,
                        swipeLeft: null,
                        swiped: !1,
                        swiping: !1,
                        touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
                        trackStyle: {},
                        trackWidth: 0,
                    },
                    l = n(6),
                    c = n.n(l),
                    u = n(1),
                    d = n.n(u);
                function p(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t &&
                            (r = r.filter(function(t) {
                                return Object.getOwnPropertyDescriptor(e, t).enumerable;
                            })),
                            n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                            ? p(n, !0).forEach(function(t) {
                                  h(e, t, n[t]);
                              })
                            : Object.getOwnPropertyDescriptors
                                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                                : p(n).forEach(function(t) {
                                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                                  });
                    }
                    return e;
                }
                function h(e, t, n) {
                    return (
                        t in e
                            ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = n),
                        e
                    );
                }
                function y(e) {
                    for (var t = [], n = T(e), r = E(e), i = n; i < r; i++)
                        e.lazyLoadedList.indexOf(i) < 0 && t.push(i);
                    return t;
                }
                function v(e) {
                    return (e && e.offsetWidth) || 0;
                }
                function b(e) {
                    return (e && e.offsetHeight) || 0;
                }
                function g(e, t) {
                    var n,
                        r,
                        i,
                        o,
                        s = 1 < arguments.length && void 0 !== t && t;
                    return (
                        (n = e.startX - e.curX),
                        (r = e.startY - e.curY),
                        (i = Math.atan2(r, n)),
                        (o = Math.round((180 * i) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
                        (o <= 45 && 0 <= o) || (o <= 360 && 315 <= o)
                            ? 'left'
                            : 135 <= o && o <= 225
                                ? 'right'
                                : !0 === s
                                    ? 35 <= o && o <= 135
                                        ? 'up'
                                        : 'down'
                                    : 'vertical'
                    );
                }
                function m(e) {
                    var t = !0;
                    return (
                        e.infinite ||
                            (e.centerMode && e.currentSlide >= e.slideCount - 1
                                ? (t = !1)
                                : (e.slideCount <= e.slidesToShow || e.currentSlide >= e.slideCount - e.slidesToShow) &&
                                  (t = !1)),
                        t
                    );
                }
                function w(e, t) {
                    var n = {};
                    return (
                        t.forEach(function(t) {
                            return (n[t] = e[t]);
                        }),
                        n
                    );
                }
                function S(e, t) {
                    return t.reduce(function(t, n) {
                        return t && e.hasOwnProperty(n);
                    }, !0)
                        ? null
                        : console.error('Keys Missing:', e);
                }
                function O(e) {
                    return e.unslick || !e.infinite ? 0 : e.slideCount;
                }
                function k() {
                    return !('undefined' == typeof window || !window.document || !window.document.createElement);
                }
                var T = function(e) {
                        return e.currentSlide - _(e);
                    },
                    E = function(e) {
                        return e.currentSlide + j(e);
                    },
                    _ = function(e) {
                        return e.centerMode
                            ? Math.floor(e.slidesToShow / 2) + (0 < parseInt(e.centerPadding) ? 1 : 0)
                            : 0;
                    },
                    j = function(e) {
                        return e.centerMode
                            ? Math.floor((e.slidesToShow - 1) / 2) + 1 + (0 < parseInt(e.centerPadding) ? 1 : 0)
                            : e.slidesToShow;
                    },
                    P = function(e, t) {
                        var n = (function(e) {
                                for (
                                    var t = e.infinite ? 2 * e.slideCount : e.slideCount,
                                        n = e.infinite ? -1 * e.slidesToShow : 0,
                                        r = e.infinite ? -1 * e.slidesToShow : 0,
                                        i = [];
                                    n < t;

                                )
                                    i.push(n),
                                        (n = r + e.slidesToScroll),
                                        (r += Math.min(e.slidesToScroll, e.slidesToShow));
                                return i;
                            })(e),
                            r = 0;
                        if (t > n[n.length - 1]) t = n[n.length - 1];
                        else
                            for (var i in n) {
                                if (t < n[i]) {
                                    t = r;
                                    break;
                                }
                                r = n[i];
                            }
                        return t;
                    },
                    x = function(e) {
                        var t = e.centerMode ? e.slideWidth * Math.floor(e.slidesToShow / 2) : 0;
                        if (e.swipeToSlide) {
                            var n,
                                r = s.a.findDOMNode(e.listRef).querySelectorAll('.slick-slide');
                            if (
                                (Array.from(r).every(function(r) {
                                    if (e.vertical) {
                                        if (r.offsetTop + b(r) / 2 > -1 * e.swipeLeft) return (n = r), !1;
                                    } else if (r.offsetLeft - t + v(r) / 2 > -1 * e.swipeLeft) return (n = r), !1;
                                    return !0;
                                }),
                                !n)
                            )
                                return 0;
                            var i = !0 === e.rtl ? e.slideCount - e.currentSlide : e.currentSlide;
                            return Math.abs(n.dataset.index - i) || 1;
                        }
                        return e.slidesToScroll;
                    },
                    L = function(e) {
                        var t, n;
                        S(e, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
                        var r = e.slideCount + 2 * e.slidesToShow;
                        e.vertical ? (n = r * e.slideHeight) : (t = D(e) * e.slideWidth);
                        var i = { opacity: 1, transition: '', WebkitTransition: '' };
                        return (
                            e.useTransform
                                ? (i = f({}, i, {
                                      WebkitTransform: e.vertical
                                          ? 'translate3d(0px, ' + e.left + 'px, 0px)'
                                          : 'translate3d(' + e.left + 'px, 0px, 0px)',
                                      transform: e.vertical
                                          ? 'translate3d(0px, ' + e.left + 'px, 0px)'
                                          : 'translate3d(' + e.left + 'px, 0px, 0px)',
                                      msTransform: e.vertical
                                          ? 'translateY(' + e.left + 'px)'
                                          : 'translateX(' + e.left + 'px)',
                                  }))
                                : e.vertical
                                    ? (i.top = e.left)
                                    : (i.left = e.left),
                            e.fade && (i = { opacity: 1 }),
                            t && (i.width = t),
                            n && (i.height = n),
                            window &&
                                !window.addEventListener &&
                                window.attachEvent &&
                                (e.vertical ? (i.marginTop = e.left + 'px') : (i.marginLeft = e.left + 'px')),
                            i
                        );
                    },
                    M = function(e) {
                        S(e, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
                        var t = L(e);
                        return (
                            e.useTransform
                                ? ((t.WebkitTransition = '-webkit-transform ' + e.speed + 'ms ' + e.cssEase),
                                  (t.transition = 'transform ' + e.speed + 'ms ' + e.cssEase))
                                : e.vertical
                                    ? (t.transition = 'top ' + e.speed + 'ms ' + e.cssEase)
                                    : (t.transition = 'left ' + e.speed + 'ms ' + e.cssEase),
                            t
                        );
                    },
                    C = function(e) {
                        if (e.unslick) return 0;
                        S(e, [
                            'slideIndex',
                            'trackRef',
                            'infinite',
                            'centerMode',
                            'slideCount',
                            'slidesToShow',
                            'slidesToScroll',
                            'slideWidth',
                            'listWidth',
                            'variableWidth',
                            'slideHeight',
                        ]);
                        var t,
                            n,
                            r = e.slideIndex,
                            i = e.trackRef,
                            o = e.infinite,
                            a = e.centerMode,
                            l = e.slideCount,
                            c = e.slidesToShow,
                            u = e.slidesToScroll,
                            d = e.slideWidth,
                            p = e.listWidth,
                            f = e.variableWidth,
                            h = e.slideHeight,
                            y = e.fade,
                            v = e.vertical;
                        if (y || 1 === e.slideCount) return 0;
                        var b = 0;
                        if (
                            (o
                                ? ((b = -z(e)),
                                  l % u != 0 && l < r + u && (b = -(l < r ? c - (r - l) : l % u)),
                                  a && (b += parseInt(c / 2)))
                                : (l % u != 0 && l < r + u && (b = c - (l % u)), a && (b = parseInt(c / 2))),
                            (t = v ? r * h * -1 + b * h : r * d * -1 + b * d),
                            !0 === f)
                        ) {
                            var g,
                                m = s.a.findDOMNode(i);
                            if (((g = r + z(e)), (t = (n = m && m.childNodes[g]) ? -1 * n.offsetLeft : 0), !0 === a)) {
                                (g = o ? r + z(e) : r), (n = m && m.children[g]);
                                for (var w = (t = 0); w < g; w++) t -= m && m.children[w] && m.children[w].offsetWidth;
                                (t -= parseInt(e.centerPadding)), (t += n && (p - n.offsetWidth) / 2);
                            }
                        }
                        return t;
                    },
                    z = function(e) {
                        return e.unslick || !e.infinite
                            ? 0
                            : e.variableWidth
                                ? e.slideCount
                                : e.slidesToShow + (e.centerMode ? 1 : 0);
                    },
                    D = function(e) {
                        return 1 === e.slideCount ? 1 : z(e) + e.slideCount + O(e);
                    },
                    W = function(e) {
                        return e.targetSlide > e.currentSlide
                            ? e.targetSlide > e.currentSlide + R(e)
                                ? 'left'
                                : 'right'
                            : e.targetSlide < e.currentSlide - H(e)
                                ? 'right'
                                : 'left';
                    },
                    R = function(e) {
                        var t = e.slidesToShow,
                            n = e.centerMode,
                            r = e.rtl,
                            i = e.centerPadding;
                        if (n) {
                            var o = (t - 1) / 2 + 1;
                            return 0 < parseInt(i) && (o += 1), r && t % 2 == 0 && (o += 1), o;
                        }
                        return r ? 0 : t - 1;
                    },
                    H = function(e) {
                        var t = e.slidesToShow,
                            n = e.centerMode,
                            r = e.rtl,
                            i = e.centerPadding;
                        if (n) {
                            var o = (t - 1) / 2 + 1;
                            return 0 < parseInt(i) && (o += 1), r || t % 2 != 0 || (o += 1), o;
                        }
                        return r ? t - 1 : 0;
                    };
                function A(e) {
                    return (A =
                        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                            ? function(e) {
                                  return typeof e;
                              }
                            : function(e) {
                                  return e &&
                                      'function' == typeof Symbol &&
                                      e.constructor === Symbol &&
                                      e !== Symbol.prototype
                                      ? 'symbol'
                                      : typeof e;
                              })(e);
                }
                function I() {
                    return (I =
                        Object.assign ||
                        function(e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                function N(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var r = t[n];
                        (r.enumerable = r.enumerable || !1),
                            (r.configurable = !0),
                            'value' in r && (r.writable = !0),
                            Object.defineProperty(e, r.key, r);
                    }
                }
                function q(e) {
                    return (q = Object.setPrototypeOf
                        ? Object.getPrototypeOf
                        : function(e) {
                              return e.__proto__ || Object.getPrototypeOf(e);
                          })(e);
                }
                function F(e, t) {
                    return (F =
                        Object.setPrototypeOf ||
                        function(e, t) {
                            return (e.__proto__ = t), e;
                        })(e, t);
                }
                function X(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t &&
                            (r = r.filter(function(t) {
                                return Object.getOwnPropertyDescriptor(e, t).enumerable;
                            })),
                            n.push.apply(n, r);
                    }
                    return n;
                }
                function Y(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                            ? X(n, !0).forEach(function(t) {
                                  B(e, t, n[t]);
                              })
                            : Object.getOwnPropertyDescriptors
                                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                                : X(n).forEach(function(t) {
                                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                                  });
                    }
                    return e;
                }
                function B(e, t, n) {
                    return (
                        t in e
                            ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = n),
                        e
                    );
                }
                function U(e) {
                    var t, n, r, i, o;
                    return (
                        (r = (o = e.rtl ? e.slideCount - 1 - e.index : e.index) < 0 || o >= e.slideCount),
                        e.centerMode
                            ? ((i = Math.floor(e.slidesToShow / 2)),
                              (n = (o - e.currentSlide) % e.slideCount == 0),
                              o > e.currentSlide - i - 1 && o <= e.currentSlide + i && (t = !0))
                            : (t = e.currentSlide <= o && o < e.currentSlide + e.slidesToShow),
                        {
                            'slick-slide': !0,
                            'slick-active': t,
                            'slick-center': n,
                            'slick-cloned': r,
                            'slick-current': o === e.currentSlide,
                        }
                    );
                }
                function G(e, t) {
                    return e.key || t;
                }
                var V = (function() {
                    function e() {
                        return (
                            (function(e, t) {
                                if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                            })(this, e),
                            (function(e, t) {
                                return !t || ('object' !== A(t) && 'function' != typeof t)
                                    ? (function(e) {
                                          if (void 0 !== e) return e;
                                          throw new ReferenceError(
                                              "this hasn't been initialised - super() hasn't been called",
                                          );
                                      })(e)
                                    : t;
                            })(this, q(e).apply(this, arguments))
                        );
                    }
                    return (
                        (function(e, t) {
                            if ('function' != typeof t && null !== t)
                                throw new TypeError('Super expression must either be null or a function');
                            (e.prototype = Object.create(t && t.prototype, {
                                constructor: { value: e, writable: !0, configurable: !0 },
                            })),
                                t && F(e, t);
                        })(e, i.a.PureComponent),
                        (function(e, t, n) {
                            t && N(e.prototype, t);
                        })(e, [
                            {
                                key: 'render',
                                value: function() {
                                    var e = (function(e) {
                                            var t,
                                                n = [],
                                                r = [],
                                                o = [],
                                                s = i.a.Children.count(e.children),
                                                a = T(e),
                                                l = E(e);
                                            return (
                                                i.a.Children.forEach(e.children, function(c, u) {
                                                    var p,
                                                        f = {
                                                            message: 'children',
                                                            index: u,
                                                            slidesToScroll: e.slidesToScroll,
                                                            currentSlide: e.currentSlide,
                                                        };
                                                    p =
                                                        !e.lazyLoad || (e.lazyLoad && 0 <= e.lazyLoadedList.indexOf(u))
                                                            ? c
                                                            : i.a.createElement('div', null);
                                                    var h = (function(e) {
                                                            var t = {};
                                                            return (
                                                                (void 0 !== e.variableWidth &&
                                                                    !1 !== e.variableWidth) ||
                                                                    (t.width = e.slideWidth),
                                                                e.fade &&
                                                                    ((t.position = 'relative'),
                                                                    e.vertical
                                                                        ? (t.top = -e.index * parseInt(e.slideHeight))
                                                                        : (t.left = -e.index * parseInt(e.slideWidth)),
                                                                    (t.opacity = e.currentSlide === e.index ? 1 : 0),
                                                                    (t.transition =
                                                                        'opacity ' +
                                                                        e.speed +
                                                                        'ms ' +
                                                                        e.cssEase +
                                                                        ', visibility ' +
                                                                        e.speed +
                                                                        'ms ' +
                                                                        e.cssEase),
                                                                    (t.WebkitTransition =
                                                                        'opacity ' +
                                                                        e.speed +
                                                                        'ms ' +
                                                                        e.cssEase +
                                                                        ', visibility ' +
                                                                        e.speed +
                                                                        'ms ' +
                                                                        e.cssEase)),
                                                                t
                                                            );
                                                        })(Y({}, e, { index: u })),
                                                        y = p.props.className || '',
                                                        v = U(Y({}, e, { index: u }));
                                                    if (
                                                        (n.push(
                                                            i.a.cloneElement(p, {
                                                                key: 'original' + G(p, u),
                                                                'data-index': u,
                                                                className: d()(v, y),
                                                                tabIndex: '-1',
                                                                'aria-hidden': !v['slick-active'],
                                                                style: Y(
                                                                    { outline: 'none' },
                                                                    p.props.style || {},
                                                                    {},
                                                                    h,
                                                                ),
                                                                onClick: function(t) {
                                                                    p.props && p.props.onClick && p.props.onClick(t),
                                                                        e.focusOnSelect && e.focusOnSelect(f);
                                                                },
                                                            }),
                                                        ),
                                                        e.infinite && !1 === e.fade)
                                                    ) {
                                                        var b = s - u;
                                                        b <= z(e) &&
                                                            s !== e.slidesToShow &&
                                                            (a <= (t = -b) && (p = c),
                                                            (v = U(Y({}, e, { index: t }))),
                                                            r.push(
                                                                i.a.cloneElement(p, {
                                                                    key: 'precloned' + G(p, t),
                                                                    'data-index': t,
                                                                    tabIndex: '-1',
                                                                    className: d()(v, y),
                                                                    'aria-hidden': !v['slick-active'],
                                                                    style: Y({}, p.props.style || {}, {}, h),
                                                                    onClick: function(t) {
                                                                        p.props &&
                                                                            p.props.onClick &&
                                                                            p.props.onClick(t),
                                                                            e.focusOnSelect && e.focusOnSelect(f);
                                                                    },
                                                                }),
                                                            )),
                                                            s !== e.slidesToShow &&
                                                                ((t = s + u) < l && (p = c),
                                                                (v = U(Y({}, e, { index: t }))),
                                                                o.push(
                                                                    i.a.cloneElement(p, {
                                                                        key: 'postcloned' + G(p, t),
                                                                        'data-index': t,
                                                                        tabIndex: '-1',
                                                                        className: d()(v, y),
                                                                        'aria-hidden': !v['slick-active'],
                                                                        style: Y({}, p.props.style || {}, {}, h),
                                                                        onClick: function(t) {
                                                                            p.props &&
                                                                                p.props.onClick &&
                                                                                p.props.onClick(t),
                                                                                e.focusOnSelect && e.focusOnSelect(f);
                                                                        },
                                                                    }),
                                                                ));
                                                    }
                                                }),
                                                e.rtl ? r.concat(n, o).reverse() : r.concat(n, o)
                                            );
                                        })(this.props),
                                        t = this.props,
                                        n = {
                                            onMouseEnter: t.onMouseEnter,
                                            onMouseOver: t.onMouseOver,
                                            onMouseLeave: t.onMouseLeave,
                                        };
                                    return i.a.createElement(
                                        'div',
                                        I({ className: 'slick-track', style: this.props.trackStyle }, n),
                                        e,
                                    );
                                },
                            },
                        ]),
                        e
                    );
                })();
                function $(e) {
                    return ($ =
                        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                            ? function(e) {
                                  return typeof e;
                              }
                            : function(e) {
                                  return e &&
                                      'function' == typeof Symbol &&
                                      e.constructor === Symbol &&
                                      e !== Symbol.prototype
                                      ? 'symbol'
                                      : typeof e;
                              })(e);
                }
                function K(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t &&
                            (r = r.filter(function(t) {
                                return Object.getOwnPropertyDescriptor(e, t).enumerable;
                            })),
                            n.push.apply(n, r);
                    }
                    return n;
                }
                function Z(e, t, n) {
                    return (
                        t in e
                            ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = n),
                        e
                    );
                }
                function J(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var r = t[n];
                        (r.enumerable = r.enumerable || !1),
                            (r.configurable = !0),
                            'value' in r && (r.writable = !0),
                            Object.defineProperty(e, r.key, r);
                    }
                }
                function Q(e) {
                    return (Q = Object.setPrototypeOf
                        ? Object.getPrototypeOf
                        : function(e) {
                              return e.__proto__ || Object.getPrototypeOf(e);
                          })(e);
                }
                function ee(e, t) {
                    return (ee =
                        Object.setPrototypeOf ||
                        function(e, t) {
                            return (e.__proto__ = t), e;
                        })(e, t);
                }
                var te = (function() {
                    function e() {
                        return (
                            (function(e, t) {
                                if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                            })(this, e),
                            (function(e, t) {
                                return !t || ('object' !== $(t) && 'function' != typeof t)
                                    ? (function(e) {
                                          if (void 0 !== e) return e;
                                          throw new ReferenceError(
                                              "this hasn't been initialised - super() hasn't been called",
                                          );
                                      })(e)
                                    : t;
                            })(this, Q(e).apply(this, arguments))
                        );
                    }
                    return (
                        (function(e, t) {
                            if ('function' != typeof t && null !== t)
                                throw new TypeError('Super expression must either be null or a function');
                            (e.prototype = Object.create(t && t.prototype, {
                                constructor: { value: e, writable: !0, configurable: !0 },
                            })),
                                t && ee(e, t);
                        })(e, i.a.PureComponent),
                        (function(e, t, n) {
                            t && J(e.prototype, t);
                        })(e, [
                            {
                                key: 'clickHandler',
                                value: function(e, t) {
                                    t.preventDefault(), this.props.clickHandler(e);
                                },
                            },
                            {
                                key: 'render',
                                value: function() {
                                    var e = this,
                                        t = (function(e) {
                                            return e.infinite
                                                ? Math.ceil(e.slideCount / e.slidesToScroll)
                                                : Math.ceil((e.slideCount - e.slidesToShow) / e.slidesToScroll) + 1;
                                        })({
                                            slideCount: this.props.slideCount,
                                            slidesToScroll: this.props.slidesToScroll,
                                            slidesToShow: this.props.slidesToShow,
                                            infinite: this.props.infinite,
                                        }),
                                        n = this.props,
                                        r = {
                                            onMouseEnter: n.onMouseEnter,
                                            onMouseOver: n.onMouseOver,
                                            onMouseLeave: n.onMouseLeave,
                                        },
                                        o = Array.apply(
                                            null,
                                            Array(t + 1)
                                                .join('0')
                                                .split(''),
                                        ).map(function(t, n) {
                                            var r = n * e.props.slidesToScroll,
                                                o = n * e.props.slidesToScroll + (e.props.slidesToScroll - 1),
                                                s = d()({
                                                    'slick-active':
                                                        e.props.currentSlide >= r && e.props.currentSlide <= o,
                                                }),
                                                a = {
                                                    message: 'dots',
                                                    index: n,
                                                    slidesToScroll: e.props.slidesToScroll,
                                                    currentSlide: e.props.currentSlide,
                                                },
                                                l = e.clickHandler.bind(e, a);
                                            return i.a.createElement(
                                                'li',
                                                { key: n, className: s },
                                                i.a.cloneElement(e.props.customPaging(n), { onClick: l }),
                                            );
                                        });
                                    return i.a.cloneElement(
                                        this.props.appendDots(o),
                                        (function(e) {
                                            for (var t = 1; t < arguments.length; t++) {
                                                var n = null != arguments[t] ? arguments[t] : {};
                                                t % 2
                                                    ? K(n, !0).forEach(function(t) {
                                                          Z(e, t, n[t]);
                                                      })
                                                    : Object.getOwnPropertyDescriptors
                                                        ? Object.defineProperties(
                                                              e,
                                                              Object.getOwnPropertyDescriptors(n),
                                                          )
                                                        : K(n).forEach(function(t) {
                                                              Object.defineProperty(
                                                                  e,
                                                                  t,
                                                                  Object.getOwnPropertyDescriptor(n, t),
                                                              );
                                                          });
                                            }
                                            return e;
                                        })({ className: this.props.dotsClass }, r),
                                    );
                                },
                            },
                        ]),
                        e
                    );
                })();
                function ne(e) {
                    return (ne =
                        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                            ? function(e) {
                                  return typeof e;
                              }
                            : function(e) {
                                  return e &&
                                      'function' == typeof Symbol &&
                                      e.constructor === Symbol &&
                                      e !== Symbol.prototype
                                      ? 'symbol'
                                      : typeof e;
                              })(e);
                }
                function re() {
                    return (re =
                        Object.assign ||
                        function(e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                function ie(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t &&
                            (r = r.filter(function(t) {
                                return Object.getOwnPropertyDescriptor(e, t).enumerable;
                            })),
                            n.push.apply(n, r);
                    }
                    return n;
                }
                function oe(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                            ? ie(n, !0).forEach(function(t) {
                                  se(e, t, n[t]);
                              })
                            : Object.getOwnPropertyDescriptors
                                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                                : ie(n).forEach(function(t) {
                                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                                  });
                    }
                    return e;
                }
                function se(e, t, n) {
                    return (
                        t in e
                            ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = n),
                        e
                    );
                }
                function ae(e, t) {
                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                }
                function le(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var r = t[n];
                        (r.enumerable = r.enumerable || !1),
                            (r.configurable = !0),
                            'value' in r && (r.writable = !0),
                            Object.defineProperty(e, r.key, r);
                    }
                }
                function ce(e, t, n) {
                    return t && le(e.prototype, t), n && le(e, n), e;
                }
                function ue(e, t) {
                    return !t || ('object' !== ne(t) && 'function' != typeof t)
                        ? (function(e) {
                              if (void 0 !== e) return e;
                              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                          })(e)
                        : t;
                }
                function de(e) {
                    return (de = Object.setPrototypeOf
                        ? Object.getPrototypeOf
                        : function(e) {
                              return e.__proto__ || Object.getPrototypeOf(e);
                          })(e);
                }
                function pe(e, t) {
                    if ('function' != typeof t && null !== t)
                        throw new TypeError('Super expression must either be null or a function');
                    (e.prototype = Object.create(t && t.prototype, {
                        constructor: { value: e, writable: !0, configurable: !0 },
                    })),
                        t &&
                            (function(e, t) {
                                (Object.setPrototypeOf ||
                                    function(e, t) {
                                        return (e.__proto__ = t), e;
                                    })(e, t);
                            })(e, t);
                }
                var fe = (function() {
                        function e() {
                            return ae(this, e), ue(this, de(e).apply(this, arguments));
                        }
                        return (
                            pe(e, i.a.PureComponent),
                            ce(e, [
                                {
                                    key: 'clickHandler',
                                    value: function(e, t) {
                                        t && t.preventDefault(), this.props.clickHandler(e, t);
                                    },
                                },
                                {
                                    key: 'render',
                                    value: function() {
                                        var e = { 'slick-arrow': !0, 'slick-prev': !0 },
                                            t = this.clickHandler.bind(this, { message: 'previous' });
                                        !this.props.infinite &&
                                            (0 === this.props.currentSlide ||
                                                this.props.slideCount <= this.props.slidesToShow) &&
                                            ((e['slick-disabled'] = !0), (t = null));
                                        var n = {
                                                key: '0',
                                                'data-role': 'none',
                                                className: d()(e),
                                                style: { display: 'block' },
                                                onClick: t,
                                            },
                                            r = {
                                                currentSlide: this.props.currentSlide,
                                                slideCount: this.props.slideCount,
                                            };
                                        return this.props.prevArrow
                                            ? i.a.cloneElement(this.props.prevArrow, oe({}, n, {}, r))
                                            : i.a.createElement(
                                                  'button',
                                                  re({ key: '0', type: 'button' }, n),
                                                  ' ',
                                                  'Previous',
                                              );
                                    },
                                },
                            ]),
                            e
                        );
                    })(),
                    he = (function() {
                        function e() {
                            return ae(this, e), ue(this, de(e).apply(this, arguments));
                        }
                        return (
                            pe(e, i.a.PureComponent),
                            ce(e, [
                                {
                                    key: 'clickHandler',
                                    value: function(e, t) {
                                        t && t.preventDefault(), this.props.clickHandler(e, t);
                                    },
                                },
                                {
                                    key: 'render',
                                    value: function() {
                                        var e = { 'slick-arrow': !0, 'slick-next': !0 },
                                            t = this.clickHandler.bind(this, { message: 'next' });
                                        m(this.props) || ((e['slick-disabled'] = !0), (t = null));
                                        var n = {
                                                key: '1',
                                                'data-role': 'none',
                                                className: d()(e),
                                                style: { display: 'block' },
                                                onClick: t,
                                            },
                                            r = {
                                                currentSlide: this.props.currentSlide,
                                                slideCount: this.props.slideCount,
                                            };
                                        return this.props.nextArrow
                                            ? i.a.cloneElement(this.props.nextArrow, oe({}, n, {}, r))
                                            : i.a.createElement(
                                                  'button',
                                                  re({ key: '1', type: 'button' }, n),
                                                  ' ',
                                                  'Next',
                                              );
                                    },
                                },
                            ]),
                            e
                        );
                    })(),
                    ye = n(7);
                function ve() {
                    return (ve =
                        Object.assign ||
                        function(e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                function be(e, t) {
                    if (null == e) return {};
                    var n,
                        r,
                        i = (function(e, t) {
                            if (null == e) return {};
                            var n,
                                r,
                                i = {},
                                o = Object.keys(e);
                            for (r = 0; r < o.length; r++) (n = o[r]), 0 <= t.indexOf(n) || (i[n] = e[n]);
                            return i;
                        })(e, t);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        for (r = 0; r < o.length; r++)
                            (n = o[r]),
                                0 <= t.indexOf(n) ||
                                    (Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]));
                    }
                    return i;
                }
                function ge(e) {
                    return (ge =
                        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                            ? function(e) {
                                  return typeof e;
                              }
                            : function(e) {
                                  return e &&
                                      'function' == typeof Symbol &&
                                      e.constructor === Symbol &&
                                      e !== Symbol.prototype
                                      ? 'symbol'
                                      : typeof e;
                              })(e);
                }
                function me(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t &&
                            (r = r.filter(function(t) {
                                return Object.getOwnPropertyDescriptor(e, t).enumerable;
                            })),
                            n.push.apply(n, r);
                    }
                    return n;
                }
                function we(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                            ? me(n, !0).forEach(function(t) {
                                  Te(e, t, n[t]);
                              })
                            : Object.getOwnPropertyDescriptors
                                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                                : me(n).forEach(function(t) {
                                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                                  });
                    }
                    return e;
                }
                function Se(e) {
                    return (Se = Object.setPrototypeOf
                        ? Object.getPrototypeOf
                        : function(e) {
                              return e.__proto__ || Object.getPrototypeOf(e);
                          })(e);
                }
                function Oe(e) {
                    if (void 0 === e)
                        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }
                function ke(e, t) {
                    return (ke =
                        Object.setPrototypeOf ||
                        function(e, t) {
                            return (e.__proto__ = t), e;
                        })(e, t);
                }
                function Te(e, t, n) {
                    return (
                        t in e
                            ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = n),
                        e
                    );
                }
                var Ee = (function() {
                        function e(t) {
                            var n;
                            return (
                                (function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                                })(this, e),
                                Te(
                                    Oe(
                                        (n = (function(e, t) {
                                            return !t || ('object' !== ge(t) && 'function' != typeof t) ? Oe(e) : t;
                                        })(this, Se(e).call(this, t))),
                                    ),
                                    'listRefHandler',
                                    function(e) {
                                        return (n.list = e);
                                    },
                                ),
                                Te(Oe(n), 'trackRefHandler', function(e) {
                                    return (n.track = e);
                                }),
                                Te(Oe(n), 'adaptHeight', function() {
                                    if (n.props.adaptiveHeight && n.list) {
                                        var e = n.list.querySelector(
                                            '[data-index="'.concat(n.state.currentSlide, '"]'),
                                        );
                                        n.list.style.height = b(e) + 'px';
                                    }
                                }),
                                Te(Oe(n), 'UNSAFE_componentWillMount', function() {
                                    if ((n.ssrInit(), n.props.onInit && n.props.onInit(), n.props.lazyLoad)) {
                                        var e = y(we({}, n.props, {}, n.state));
                                        0 < e.length &&
                                            (n.setState(function(t) {
                                                return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                                            }),
                                            n.props.onLazyLoad && n.props.onLazyLoad(e));
                                    }
                                }),
                                Te(Oe(n), 'componentDidMount', function() {
                                    var e = we({ listRef: n.list, trackRef: n.track }, n.props);
                                    n.updateState(e, !0, function() {
                                        n.adaptHeight(), n.props.autoplay && n.autoPlay('update');
                                    }),
                                        'progressive' === n.props.lazyLoad &&
                                            (n.lazyLoadTimer = setInterval(n.progressiveLazyLoad, 1e3)),
                                        (n.ro = new ye.a(function() {
                                            n.state.animating
                                                ? (n.onWindowResized(!1),
                                                  n.callbackTimers.push(
                                                      setTimeout(function() {
                                                          return n.onWindowResized();
                                                      }, n.props.speed),
                                                  ))
                                                : n.onWindowResized();
                                        })),
                                        n.ro.observe(n.list),
                                        Array.prototype.forEach.call(
                                            document.querySelectorAll('.slick-slide'),
                                            function(e) {
                                                (e.onfocus = n.props.pauseOnFocus ? n.onSlideFocus : null),
                                                    (e.onblur = n.props.pauseOnFocus ? n.onSlideBlur : null);
                                            },
                                        ),
                                        window &&
                                            (window.addEventListener
                                                ? window.addEventListener('resize', n.onWindowResized)
                                                : window.attachEvent('onresize', n.onWindowResized));
                                }),
                                Te(Oe(n), 'componentWillUnmount', function() {
                                    n.animationEndCallback && clearTimeout(n.animationEndCallback),
                                        n.lazyLoadTimer && clearInterval(n.lazyLoadTimer),
                                        n.callbackTimers.length &&
                                            (n.callbackTimers.forEach(function(e) {
                                                return clearTimeout(e);
                                            }),
                                            (n.callbackTimers = [])),
                                        window.addEventListener
                                            ? window.removeEventListener('resize', n.onWindowResized)
                                            : window.detachEvent('onresize', n.onWindowResized),
                                        n.autoplayTimer && clearInterval(n.autoplayTimer);
                                }),
                                Te(Oe(n), 'UNSAFE_componentWillReceiveProps', function(e) {
                                    for (
                                        var t = we({ listRef: n.list, trackRef: n.track }, e, {}, n.state),
                                            r = !1,
                                            o = 0,
                                            s = Object.keys(n.props);
                                        o < s.length;
                                        o++
                                    ) {
                                        var a = s[o];
                                        if (!e.hasOwnProperty(a)) {
                                            r = !0;
                                            break;
                                        }
                                        if ('object' !== ge(e[a]) && 'function' != typeof e[a] && e[a] !== n.props[a]) {
                                            r = !0;
                                            break;
                                        }
                                    }
                                    n.updateState(t, r, function() {
                                        n.state.currentSlide >= i.a.Children.count(e.children) &&
                                            n.changeSlide({
                                                message: 'index',
                                                index: i.a.Children.count(e.children) - e.slidesToShow,
                                                currentSlide: n.state.currentSlide,
                                            }),
                                            e.autoplay ? n.autoPlay('update') : n.pause('paused');
                                    });
                                }),
                                Te(Oe(n), 'componentDidUpdate', function() {
                                    if (
                                        (n.checkImagesLoad(), n.props.onReInit && n.props.onReInit(), n.props.lazyLoad)
                                    ) {
                                        var e = y(we({}, n.props, {}, n.state));
                                        0 < e.length &&
                                            (n.setState(function(t) {
                                                return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                                            }),
                                            n.props.onLazyLoad && n.props.onLazyLoad(e));
                                    }
                                    n.adaptHeight();
                                }),
                                Te(Oe(n), 'onWindowResized', function(e) {
                                    n.debouncedResize && n.debouncedResize.cancel(),
                                        (n.debouncedResize = c()(function() {
                                            return n.resizeWindow(e);
                                        }, 50)),
                                        n.debouncedResize();
                                }),
                                Te(Oe(n), 'resizeWindow', function() {
                                    var e = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0];
                                    if (s.a.findDOMNode(n.track)) {
                                        var t = we({ listRef: n.list, trackRef: n.track }, n.props, {}, n.state);
                                        n.updateState(t, e, function() {
                                            n.props.autoplay ? n.autoPlay('update') : n.pause('paused');
                                        }),
                                            n.setState({ animating: !1 }),
                                            clearTimeout(n.animationEndCallback),
                                            delete n.animationEndCallback;
                                    }
                                }),
                                Te(Oe(n), 'updateState', function(e, t, r) {
                                    var o = (function(e) {
                                        var t,
                                            n = i.a.Children.count(e.children),
                                            r = Math.ceil(v(s.a.findDOMNode(e.listRef))),
                                            o = Math.ceil(v(s.a.findDOMNode(e.trackRef)));
                                        if (e.vertical) t = r;
                                        else {
                                            var a = e.centerMode && 2 * parseInt(e.centerPadding);
                                            'string' == typeof e.centerPadding &&
                                                '%' === e.centerPadding.slice(-1) &&
                                                (a *= r / 100),
                                                (t = Math.ceil((r - a) / e.slidesToShow));
                                        }
                                        var l =
                                                s.a.findDOMNode(e.listRef) &&
                                                b(s.a.findDOMNode(e.listRef).querySelector('[data-index="0"]')),
                                            c = l * e.slidesToShow,
                                            u = void 0 === e.currentSlide ? e.initialSlide : e.currentSlide;
                                        e.rtl && void 0 === e.currentSlide && (u = n - 1 - e.initialSlide);
                                        var d = e.lazyLoadedList || [],
                                            p = y({ currentSlide: u, lazyLoadedList: d });
                                        d.concat(p);
                                        var f = {
                                            slideCount: n,
                                            slideWidth: t,
                                            listWidth: r,
                                            trackWidth: o,
                                            currentSlide: u,
                                            slideHeight: l,
                                            listHeight: c,
                                            lazyLoadedList: d,
                                        };
                                        return null === e.autoplaying && e.autoplay && (f.autoplaying = 'playing'), f;
                                    })(e);
                                    e = we({}, (e = we({}, e, {}, o, { slideIndex: o.currentSlide })), { left: C(e) });
                                    var a = L(e);
                                    (!t && i.a.Children.count(n.props.children) === i.a.Children.count(e.children)) ||
                                        (o.trackStyle = a),
                                        n.setState(o, r);
                                }),
                                Te(Oe(n), 'ssrInit', function() {
                                    if (n.props.variableWidth) {
                                        var e = 0,
                                            t = 0,
                                            r = [],
                                            o = z(
                                                we({}, n.props, {}, n.state, { slideCount: n.props.children.length }),
                                            ),
                                            s = O(
                                                we({}, n.props, {}, n.state, { slideCount: n.props.children.length }),
                                            );
                                        n.props.children.forEach(function(t) {
                                            r.push(t.props.style.width), (e += t.props.style.width);
                                        });
                                        for (var a = 0; a < o; a++)
                                            (t += r[r.length - 1 - a]), (e += r[r.length - 1 - a]);
                                        for (var l = 0; l < s; l++) e += r[l];
                                        for (var c = 0; c < n.state.currentSlide; c++) t += r[c];
                                        var u = { width: e + 'px', left: -t + 'px' };
                                        if (n.props.centerMode) {
                                            var d = ''.concat(r[n.state.currentSlide], 'px');
                                            u.left = 'calc('.concat(u.left, ' + (100% - ').concat(d, ') / 2 ) ');
                                        }
                                        n.setState({ trackStyle: u });
                                    } else {
                                        var p = i.a.Children.count(n.props.children),
                                            f = we({}, n.props, {}, n.state, { slideCount: p }),
                                            h = z(f) + O(f) + p,
                                            y = (100 / n.props.slidesToShow) * h,
                                            v = 100 / h,
                                            b = (-v * (z(f) + n.state.currentSlide) * y) / 100;
                                        n.props.centerMode && (b += (100 - (v * y) / 100) / 2);
                                        var g = { width: y + '%', left: b + '%' };
                                        n.setState({ slideWidth: v + '%', trackStyle: g });
                                    }
                                }),
                                Te(Oe(n), 'checkImagesLoad', function() {
                                    var e = document.querySelectorAll('.slick-slide img'),
                                        t = e.length,
                                        r = 0;
                                    Array.prototype.forEach.call(e, function(e) {
                                        function i() {
                                            return ++r && t <= r && n.onWindowResized();
                                        }
                                        if (e.onclick) {
                                            var o = e.onclick;
                                            e.onclick = function() {
                                                o(), e.parentNode.focus();
                                            };
                                        } else
                                            e.onclick = function() {
                                                return e.parentNode.focus();
                                            };
                                        e.onload ||
                                            (n.props.lazyLoad
                                                ? (e.onload = function() {
                                                      n.adaptHeight(),
                                                          n.callbackTimers.push(
                                                              setTimeout(n.onWindowResized, n.props.speed),
                                                          );
                                                  })
                                                : ((e.onload = i),
                                                  (e.onerror = function() {
                                                      i(), n.props.onLazyLoadError && n.props.onLazyLoadError();
                                                  })));
                                    });
                                }),
                                Te(Oe(n), 'progressiveLazyLoad', function() {
                                    for (
                                        var e = [], t = we({}, n.props, {}, n.state), r = n.state.currentSlide;
                                        r < n.state.slideCount + O(t);
                                        r++
                                    )
                                        if (n.state.lazyLoadedList.indexOf(r) < 0) {
                                            e.push(r);
                                            break;
                                        }
                                    for (var i = n.state.currentSlide - 1; i >= -z(t); i--)
                                        if (n.state.lazyLoadedList.indexOf(i) < 0) {
                                            e.push(i);
                                            break;
                                        }
                                    0 < e.length
                                        ? (n.setState(function(t) {
                                              return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                                          }),
                                          n.props.onLazyLoad && n.props.onLazyLoad(e))
                                        : n.lazyLoadTimer && (clearInterval(n.lazyLoadTimer), delete n.lazyLoadTimer);
                                }),
                                Te(Oe(n), 'slideHandler', function(e) {
                                    var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
                                        r = n.props,
                                        i = r.asNavFor,
                                        o = r.beforeChange,
                                        s = r.onLazyLoad,
                                        a = r.speed,
                                        l = r.afterChange,
                                        c = n.state.currentSlide,
                                        u = (function(e) {
                                            var t = e.waitForAnimate,
                                                n = e.animating,
                                                r = e.fade,
                                                i = e.infinite,
                                                o = e.index,
                                                s = e.slideCount,
                                                a = e.lazyLoadedList,
                                                l = e.lazyLoad,
                                                c = e.currentSlide,
                                                u = e.centerMode,
                                                d = e.slidesToScroll,
                                                p = e.slidesToShow,
                                                h = e.useCSS;
                                            if (t && n) return {};
                                            var v,
                                                b,
                                                g,
                                                w = o,
                                                S = {},
                                                O = {};
                                            if (r) {
                                                if (!i && (o < 0 || s <= o)) return {};
                                                o < 0 ? (w = o + s) : s <= o && (w = o - s),
                                                    l && a.indexOf(w) < 0 && a.push(w),
                                                    (O = {
                                                        animating: !(S = {
                                                            animating: !0,
                                                            currentSlide: w,
                                                            lazyLoadedList: a,
                                                        }),
                                                    });
                                            } else
                                                (v = w) < 0
                                                    ? ((v = w + s), i ? s % d != 0 && (v = s - (s % d)) : (v = 0))
                                                    : !m(e) && c < w
                                                        ? (w = v = c)
                                                        : u && s <= w
                                                            ? ((w = i ? s : s - 1), (v = i ? 0 : s - 1))
                                                            : s <= w &&
                                                              ((v = w - s), i ? s % d != 0 && (v = 0) : (v = s - p)),
                                                    (b = C(f({}, e, { slideIndex: w }))),
                                                    (g = C(f({}, e, { slideIndex: v }))),
                                                    i || (b === g && (w = v), (b = g)),
                                                    l && a.concat(y(f({}, e, { currentSlide: w }))),
                                                    h
                                                        ? (O = {
                                                              animating: !(S = {
                                                                  animating: !0,
                                                                  currentSlide: v,
                                                                  trackStyle: M(f({}, e, { left: b })),
                                                                  lazyLoadedList: a,
                                                              }),
                                                              currentSlide: v,
                                                              trackStyle: L(f({}, e, { left: g })),
                                                              swipeLeft: null,
                                                          })
                                                        : (S = {
                                                              currentSlide: v,
                                                              trackStyle: L(f({}, e, { left: g })),
                                                              lazyLoadedList: a,
                                                          });
                                            return { state: S, nextState: O };
                                        })(
                                            we({ index: e }, n.props, {}, n.state, {
                                                trackRef: n.track,
                                                useCSS: n.props.useCSS && !t,
                                            }),
                                        ),
                                        d = u.state,
                                        p = u.nextState;
                                    if (d) {
                                        o && o(c, d.currentSlide);
                                        var h = d.lazyLoadedList.filter(function(e) {
                                            return n.state.lazyLoadedList.indexOf(e) < 0;
                                        });
                                        s && 0 < h.length && s(h),
                                            n.setState(d, function() {
                                                i && i.innerSlider.slideHandler(e),
                                                    p &&
                                                        (n.animationEndCallback = setTimeout(function() {
                                                            var e = p.animating,
                                                                t = be(p, ['animating']);
                                                            n.setState(t, function() {
                                                                n.callbackTimers.push(
                                                                    setTimeout(function() {
                                                                        return n.setState({ animating: e });
                                                                    }, 10),
                                                                ),
                                                                    l && l(d.currentSlide),
                                                                    delete n.animationEndCallback;
                                                            });
                                                        }, a));
                                            });
                                    }
                                }),
                                Te(Oe(n), 'changeSlide', function(e) {
                                    var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
                                        r = (function(e, t) {
                                            var n,
                                                r,
                                                i,
                                                o,
                                                s = e.slidesToScroll,
                                                a = e.slidesToShow,
                                                l = e.slideCount,
                                                c = e.currentSlide,
                                                u = e.lazyLoad,
                                                d = e.infinite;
                                            if (((n = l % s != 0 ? 0 : (l - c) % s), 'previous' === t.message))
                                                (o = c - (i = 0 == n ? s : a - n)),
                                                    u && !d && (o = -1 == (r = c - i) ? l - 1 : r);
                                            else if ('next' === t.message)
                                                (o = c + (i = 0 == n ? s : n)), u && !d && (o = ((c + s) % l) + n);
                                            else if ('dots' === t.message) {
                                                if ((o = t.index * t.slidesToScroll) === t.currentSlide) return null;
                                            } else if ('children' === t.message) {
                                                if ((o = t.index) === t.currentSlide) return null;
                                                if (d) {
                                                    var p = W(f({}, e, { targetSlide: o }));
                                                    o > t.currentSlide && 'left' === p
                                                        ? (o -= l)
                                                        : o < t.currentSlide && 'right' === p && (o += l);
                                                }
                                            } else if (
                                                'index' === t.message &&
                                                (o = Number(t.index)) === t.currentSlide
                                            )
                                                return null;
                                            return o;
                                        })(we({}, n.props, {}, n.state), e);
                                    (0 !== r && !r) || (!0 === t ? n.slideHandler(r, t) : n.slideHandler(r));
                                }),
                                Te(Oe(n), 'clickHandler', function(e) {
                                    !1 === n.clickable && (e.stopPropagation(), e.preventDefault()), (n.clickable = !0);
                                }),
                                Te(Oe(n), 'keyHandler', function(e) {
                                    var t = (function(e, t, n) {
                                        return e.target.tagName.match('TEXTAREA|INPUT|SELECT') || !t
                                            ? ''
                                            : 37 === e.keyCode
                                                ? n
                                                    ? 'next'
                                                    : 'previous'
                                                : 39 === e.keyCode
                                                    ? n
                                                        ? 'previous'
                                                        : 'next'
                                                    : '';
                                    })(e, n.props.accessibility, n.props.rtl);
                                    '' !== t && n.changeSlide({ message: t });
                                }),
                                Te(Oe(n), 'selectHandler', function(e) {
                                    n.changeSlide(e);
                                }),
                                Te(Oe(n), 'disableBodyScroll', function() {
                                    window.ontouchmove = function(e) {
                                        (e = e || window.event).preventDefault && e.preventDefault(),
                                            (e.returnValue = !1);
                                    };
                                }),
                                Te(Oe(n), 'enableBodyScroll', function() {
                                    window.ontouchmove = null;
                                }),
                                Te(Oe(n), 'swipeStart', function(e) {
                                    n.props.verticalSwiping && n.disableBodyScroll();
                                    var t = (function(e, t, n) {
                                        return (
                                            'IMG' === e.target.tagName && e.preventDefault(),
                                            !t || (!n && -1 !== e.type.indexOf('mouse'))
                                                ? ''
                                                : {
                                                      dragging: !0,
                                                      touchObject: {
                                                          startX: e.touches ? e.touches[0].pageX : e.clientX,
                                                          startY: e.touches ? e.touches[0].pageY : e.clientY,
                                                          curX: e.touches ? e.touches[0].pageX : e.clientX,
                                                          curY: e.touches ? e.touches[0].pageY : e.clientY,
                                                      },
                                                  }
                                        );
                                    })(e, n.props.swipe, n.props.draggable);
                                    '' !== t && n.setState(t);
                                }),
                                Te(Oe(n), 'swipeMove', function(e) {
                                    var t = (function(e, t) {
                                        var n = t.scrolling,
                                            r = t.animating,
                                            i = t.vertical,
                                            o = t.swipeToSlide,
                                            s = t.verticalSwiping,
                                            a = t.rtl,
                                            l = t.currentSlide,
                                            c = t.edgeFriction,
                                            u = t.edgeDragged,
                                            d = t.onEdge,
                                            p = t.swiped,
                                            h = t.swiping,
                                            y = t.slideCount,
                                            v = t.slidesToScroll,
                                            b = t.infinite,
                                            w = t.touchObject,
                                            S = t.swipeEvent,
                                            O = t.listHeight,
                                            k = t.listWidth;
                                        if (!n) {
                                            if (r) return e.preventDefault();
                                            i && o && s && e.preventDefault();
                                            var T,
                                                E = {},
                                                _ = C(t);
                                            (w.curX = e.touches ? e.touches[0].pageX : e.clientX),
                                                (w.curY = e.touches ? e.touches[0].pageY : e.clientY),
                                                (w.swipeLength = Math.round(Math.sqrt(Math.pow(w.curX - w.startX, 2))));
                                            var j = Math.round(Math.sqrt(Math.pow(w.curY - w.startY, 2)));
                                            if (!s && !h && 10 < j) return { scrolling: !0 };
                                            s && (w.swipeLength = j);
                                            var P = (a ? -1 : 1) * (w.curX > w.startX ? 1 : -1);
                                            s && (P = w.curY > w.startY ? 1 : -1);
                                            var x = Math.ceil(y / v),
                                                M = g(t.touchObject, s),
                                                z = w.swipeLength;
                                            return (
                                                b ||
                                                    (((0 === l && 'right' === M) ||
                                                        (x <= l + 1 && 'left' === M) ||
                                                        (!m(t) && 'left' === M)) &&
                                                        ((z = w.swipeLength * c),
                                                        !1 === u && d && (d(M), (E.edgeDragged = !0)))),
                                                !p && S && (S(M), (E.swiped = !0)),
                                                (T = i ? _ + z * (O / k) * P : a ? _ - z * P : _ + z * P),
                                                s && (T = _ + z * P),
                                                (E = f({}, E, {
                                                    touchObject: w,
                                                    swipeLeft: T,
                                                    trackStyle: L(f({}, t, { left: T })),
                                                })),
                                                Math.abs(w.curX - w.startX) < 0.8 * Math.abs(w.curY - w.startY)
                                                    ? E
                                                    : (10 < w.swipeLength && ((E.swiping = !0), e.preventDefault()), E)
                                            );
                                        }
                                    })(
                                        e,
                                        we({}, n.props, {}, n.state, {
                                            trackRef: n.track,
                                            listRef: n.list,
                                            slideIndex: n.state.currentSlide,
                                        }),
                                    );
                                    t && (t.swiping && (n.clickable = !1), n.setState(t));
                                }),
                                Te(Oe(n), 'swipeEnd', function(e) {
                                    var t = (function(e, t) {
                                        var n = t.dragging,
                                            r = t.swipe,
                                            i = t.touchObject,
                                            o = t.listWidth,
                                            s = t.touchThreshold,
                                            a = t.verticalSwiping,
                                            l = t.listHeight,
                                            c = t.currentSlide,
                                            u = t.swipeToSlide,
                                            d = t.scrolling,
                                            p = t.onSwipe;
                                        if (!n) return r && e.preventDefault(), {};
                                        var h = a ? l / s : o / s,
                                            y = g(i, a),
                                            v = {
                                                dragging: !1,
                                                edgeDragged: !1,
                                                scrolling: !1,
                                                swiping: !1,
                                                swiped: !1,
                                                swipeLeft: null,
                                                touchObject: {},
                                            };
                                        if (d) return v;
                                        if (!i.swipeLength) return v;
                                        if (i.swipeLength > h) {
                                            var b, m;
                                            switch ((e.preventDefault(), p && p(y), y)) {
                                                case 'left':
                                                case 'up':
                                                    (m = c + x(t)), (b = u ? P(t, m) : m), (v.currentDirection = 0);
                                                    break;
                                                case 'right':
                                                case 'down':
                                                    (m = c - x(t)), (b = u ? P(t, m) : m), (v.currentDirection = 1);
                                                    break;
                                                default:
                                                    b = c;
                                            }
                                            v.triggerSlideHandler = b;
                                        } else {
                                            var w = C(t);
                                            v.trackStyle = M(f({}, t, { left: w }));
                                        }
                                        return v;
                                    })(
                                        e,
                                        we({}, n.props, {}, n.state, {
                                            trackRef: n.track,
                                            listRef: n.list,
                                            slideIndex: n.state.currentSlide,
                                        }),
                                    );
                                    if (t) {
                                        var r = t.triggerSlideHandler;
                                        delete t.triggerSlideHandler,
                                            n.setState(t),
                                            void 0 !== r &&
                                                (n.slideHandler(r), n.props.verticalSwiping && n.enableBodyScroll());
                                    }
                                }),
                                Te(Oe(n), 'slickPrev', function() {
                                    n.callbackTimers.push(
                                        setTimeout(function() {
                                            return n.changeSlide({ message: 'previous' });
                                        }, 0),
                                    );
                                }),
                                Te(Oe(n), 'slickNext', function() {
                                    n.callbackTimers.push(
                                        setTimeout(function() {
                                            return n.changeSlide({ message: 'next' });
                                        }, 0),
                                    );
                                }),
                                Te(Oe(n), 'slickGoTo', function(e) {
                                    var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
                                    if (((e = Number(e)), isNaN(e))) return '';
                                    n.callbackTimers.push(
                                        setTimeout(function() {
                                            return n.changeSlide(
                                                { message: 'index', index: e, currentSlide: n.state.currentSlide },
                                                t,
                                            );
                                        }, 0),
                                    );
                                }),
                                Te(Oe(n), 'play', function() {
                                    var e;
                                    if (n.props.rtl) e = n.state.currentSlide - n.props.slidesToScroll;
                                    else {
                                        if (!m(we({}, n.props, {}, n.state))) return !1;
                                        e = n.state.currentSlide + n.props.slidesToScroll;
                                    }
                                    n.slideHandler(e);
                                }),
                                Te(Oe(n), 'autoPlay', function(e) {
                                    n.autoplayTimer && clearInterval(n.autoplayTimer);
                                    var t = n.state.autoplaying;
                                    if ('update' === e) {
                                        if ('hovered' === t || 'focused' === t || 'paused' === t) return;
                                    } else if ('leave' === e) {
                                        if ('paused' === t || 'focused' === t) return;
                                    } else if ('blur' === e && ('paused' === t || 'hovered' === t)) return;
                                    (n.autoplayTimer = setInterval(n.play, n.props.autoplaySpeed + 50)),
                                        n.setState({ autoplaying: 'playing' });
                                }),
                                Te(Oe(n), 'pause', function(e) {
                                    n.autoplayTimer && (clearInterval(n.autoplayTimer), (n.autoplayTimer = null));
                                    var t = n.state.autoplaying;
                                    'paused' === e
                                        ? n.setState({ autoplaying: 'paused' })
                                        : 'focused' === e
                                            ? ('hovered' !== t && 'playing' !== t) ||
                                              n.setState({ autoplaying: 'focused' })
                                            : 'playing' === t && n.setState({ autoplaying: 'hovered' });
                                }),
                                Te(Oe(n), 'onDotsOver', function() {
                                    return n.props.autoplay && n.pause('hovered');
                                }),
                                Te(Oe(n), 'onDotsLeave', function() {
                                    return n.props.autoplay && 'hovered' === n.state.autoplaying && n.autoPlay('leave');
                                }),
                                Te(Oe(n), 'onTrackOver', function() {
                                    return n.props.autoplay && n.pause('hovered');
                                }),
                                Te(Oe(n), 'onTrackLeave', function() {
                                    return n.props.autoplay && 'hovered' === n.state.autoplaying && n.autoPlay('leave');
                                }),
                                Te(Oe(n), 'onSlideFocus', function() {
                                    return n.props.autoplay && n.pause('focused');
                                }),
                                Te(Oe(n), 'onSlideBlur', function() {
                                    return n.props.autoplay && 'focused' === n.state.autoplaying && n.autoPlay('blur');
                                }),
                                Te(Oe(n), 'render', function() {
                                    var e,
                                        t,
                                        r,
                                        o = d()('slick-slider', n.props.className, {
                                            'slick-vertical': n.props.vertical,
                                            'slick-initialized': !0,
                                        }),
                                        s = we({}, n.props, {}, n.state),
                                        a = w(s, [
                                            'fade',
                                            'cssEase',
                                            'speed',
                                            'infinite',
                                            'centerMode',
                                            'focusOnSelect',
                                            'currentSlide',
                                            'lazyLoad',
                                            'lazyLoadedList',
                                            'rtl',
                                            'slideWidth',
                                            'slideHeight',
                                            'listHeight',
                                            'vertical',
                                            'slidesToShow',
                                            'slidesToScroll',
                                            'slideCount',
                                            'trackStyle',
                                            'variableWidth',
                                            'unslick',
                                            'centerPadding',
                                        ]),
                                        l = n.props.pauseOnHover;
                                    if (
                                        ((a = we({}, a, {
                                            onMouseEnter: l ? n.onTrackOver : null,
                                            onMouseLeave: l ? n.onTrackLeave : null,
                                            onMouseOver: l ? n.onTrackOver : null,
                                            focusOnSelect: n.props.focusOnSelect ? n.selectHandler : null,
                                        })),
                                        !0 === n.props.dots && n.state.slideCount >= n.props.slidesToShow)
                                    ) {
                                        var c = w(s, [
                                                'dotsClass',
                                                'slideCount',
                                                'slidesToShow',
                                                'currentSlide',
                                                'slidesToScroll',
                                                'clickHandler',
                                                'children',
                                                'customPaging',
                                                'infinite',
                                                'appendDots',
                                            ]),
                                            u = n.props.pauseOnDotsHover;
                                        (c = we({}, c, {
                                            clickHandler: n.changeSlide,
                                            onMouseEnter: u ? n.onDotsLeave : null,
                                            onMouseOver: u ? n.onDotsOver : null,
                                            onMouseLeave: u ? n.onDotsLeave : null,
                                        })),
                                            (e = i.a.createElement(te, c));
                                    }
                                    var p = w(s, [
                                        'infinite',
                                        'centerMode',
                                        'currentSlide',
                                        'slideCount',
                                        'slidesToShow',
                                        'prevArrow',
                                        'nextArrow',
                                    ]);
                                    (p.clickHandler = n.changeSlide),
                                        n.props.arrows &&
                                            ((t = i.a.createElement(fe, p)), (r = i.a.createElement(he, p)));
                                    var f = null;
                                    n.props.vertical && (f = { height: n.state.listHeight });
                                    var h = null;
                                    !1 === n.props.vertical
                                        ? !0 === n.props.centerMode && (h = { padding: '0px ' + n.props.centerPadding })
                                        : !0 === n.props.centerMode &&
                                          (h = { padding: n.props.centerPadding + ' 0px' });
                                    var y = we({}, f, {}, h),
                                        v = n.props.touchMove,
                                        b = {
                                            className: 'slick-list',
                                            style: y,
                                            onClick: n.clickHandler,
                                            onMouseDown: v ? n.swipeStart : null,
                                            onMouseMove: n.state.dragging && v ? n.swipeMove : null,
                                            onMouseUp: v ? n.swipeEnd : null,
                                            onMouseLeave: n.state.dragging && v ? n.swipeEnd : null,
                                            onTouchStart: v ? n.swipeStart : null,
                                            onTouchMove: n.state.dragging && v ? n.swipeMove : null,
                                            onTouchEnd: v ? n.swipeEnd : null,
                                            onTouchCancel: n.state.dragging && v ? n.swipeEnd : null,
                                            onKeyDown: n.props.accessibility ? n.keyHandler : null,
                                        },
                                        g = { className: o, dir: 'ltr', style: n.props.style };
                                    return (
                                        n.props.unslick && ((b = { className: 'slick-list' }), (g = { className: o })),
                                        i.a.createElement(
                                            'div',
                                            g,
                                            n.props.unslick ? '' : t,
                                            i.a.createElement(
                                                'div',
                                                ve({ ref: n.listRefHandler }, b),
                                                i.a.createElement(
                                                    V,
                                                    ve({ ref: n.trackRefHandler }, a),
                                                    n.props.children,
                                                ),
                                            ),
                                            n.props.unslick ? '' : r,
                                            n.props.unslick ? '' : e,
                                        )
                                    );
                                }),
                                (n.list = null),
                                (n.track = null),
                                (n.state = we({}, a, {
                                    currentSlide: n.props.initialSlide,
                                    slideCount: i.a.Children.count(n.props.children),
                                })),
                                (n.callbackTimers = []),
                                (n.clickable = !0),
                                (n.debouncedResize = null),
                                n
                            );
                        }
                        return (
                            (function(e, t) {
                                if ('function' != typeof t && null !== t)
                                    throw new TypeError('Super expression must either be null or a function');
                                (e.prototype = Object.create(t && t.prototype, {
                                    constructor: { value: e, writable: !0, configurable: !0 },
                                })),
                                    t && ke(e, t);
                            })(e, i.a.Component),
                            e
                        );
                    })(),
                    _e = n(3),
                    je = n.n(_e),
                    Pe = {
                        accessibility: !0,
                        adaptiveHeight: !1,
                        afterChange: null,
                        appendDots: function(e) {
                            return i.a.createElement('ul', { style: { display: 'block' } }, e);
                        },
                        arrows: !0,
                        autoplay: !1,
                        autoplaySpeed: 3e3,
                        beforeChange: null,
                        centerMode: !1,
                        centerPadding: '50px',
                        className: '',
                        cssEase: 'ease',
                        customPaging: function(e) {
                            return i.a.createElement('button', null, e + 1);
                        },
                        dots: !1,
                        dotsClass: 'slick-dots',
                        draggable: !0,
                        easing: 'linear',
                        edgeFriction: 0.35,
                        fade: !1,
                        focusOnSelect: !1,
                        infinite: !0,
                        initialSlide: 0,
                        lazyLoad: null,
                        nextArrow: null,
                        onEdge: null,
                        onInit: null,
                        onLazyLoadError: null,
                        onReInit: null,
                        pauseOnDotsHover: !1,
                        pauseOnFocus: !1,
                        pauseOnHover: !0,
                        prevArrow: null,
                        responsive: null,
                        rows: 1,
                        rtl: !1,
                        slide: 'div',
                        slidesPerRow: 1,
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        speed: 500,
                        swipe: !0,
                        swipeEvent: null,
                        swipeToSlide: !1,
                        touchMove: !0,
                        touchThreshold: 5,
                        useCSS: !0,
                        useTransform: !0,
                        variableWidth: !1,
                        vertical: !1,
                        waitForAnimate: !0,
                    };
                function xe(e) {
                    return (xe =
                        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                            ? function(e) {
                                  return typeof e;
                              }
                            : function(e) {
                                  return e &&
                                      'function' == typeof Symbol &&
                                      e.constructor === Symbol &&
                                      e !== Symbol.prototype
                                      ? 'symbol'
                                      : typeof e;
                              })(e);
                }
                function Le() {
                    return (Le =
                        Object.assign ||
                        function(e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                            }
                            return e;
                        }).apply(this, arguments);
                }
                function Me(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e);
                        t &&
                            (r = r.filter(function(t) {
                                return Object.getOwnPropertyDescriptor(e, t).enumerable;
                            })),
                            n.push.apply(n, r);
                    }
                    return n;
                }
                function Ce(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                            ? Me(n, !0).forEach(function(t) {
                                  He(e, t, n[t]);
                              })
                            : Object.getOwnPropertyDescriptors
                                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
                                : Me(n).forEach(function(t) {
                                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                                  });
                    }
                    return e;
                }
                function ze(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var r = t[n];
                        (r.enumerable = r.enumerable || !1),
                            (r.configurable = !0),
                            'value' in r && (r.writable = !0),
                            Object.defineProperty(e, r.key, r);
                    }
                }
                function De(e) {
                    return (De = Object.setPrototypeOf
                        ? Object.getPrototypeOf
                        : function(e) {
                              return e.__proto__ || Object.getPrototypeOf(e);
                          })(e);
                }
                function We(e) {
                    if (void 0 === e)
                        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }
                function Re(e, t) {
                    return (Re =
                        Object.setPrototypeOf ||
                        function(e, t) {
                            return (e.__proto__ = t), e;
                        })(e, t);
                }
                function He(e, t, n) {
                    return (
                        t in e
                            ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
                            : (e[t] = n),
                        e
                    );
                }
                var Ae = k() && n(9),
                    Ie = (function() {
                        function e(t) {
                            var n;
                            return (
                                (function(e, t) {
                                    if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
                                })(this, e),
                                He(
                                    We(
                                        (n = (function(e, t) {
                                            return !t || ('object' !== xe(t) && 'function' != typeof t) ? We(e) : t;
                                        })(this, De(e).call(this, t))),
                                    ),
                                    'innerSliderRefHandler',
                                    function(e) {
                                        return (n.innerSlider = e);
                                    },
                                ),
                                He(We(n), 'slickPrev', function() {
                                    return n.innerSlider.slickPrev();
                                }),
                                He(We(n), 'slickNext', function() {
                                    return n.innerSlider.slickNext();
                                }),
                                He(We(n), 'slickGoTo', function(e) {
                                    var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
                                    return n.innerSlider.slickGoTo(e, t);
                                }),
                                He(We(n), 'slickPause', function() {
                                    return n.innerSlider.pause('paused');
                                }),
                                He(We(n), 'slickPlay', function() {
                                    return n.innerSlider.autoPlay('play');
                                }),
                                (n.state = { breakpoint: null }),
                                (n._responsiveMediaHandlers = []),
                                n
                            );
                        }
                        return (
                            (function(e, t) {
                                if ('function' != typeof t && null !== t)
                                    throw new TypeError('Super expression must either be null or a function');
                                (e.prototype = Object.create(t && t.prototype, {
                                    constructor: { value: e, writable: !0, configurable: !0 },
                                })),
                                    t && Re(e, t);
                            })(e, i.a.Component),
                            (function(e, t, n) {
                                t && ze(e.prototype, t);
                            })(e, [
                                {
                                    key: 'media',
                                    value: function(e, t) {
                                        Ae.register(e, t), this._responsiveMediaHandlers.push({ query: e, handler: t });
                                    },
                                },
                                {
                                    key: 'UNSAFE_componentWillMount',
                                    value: function() {
                                        var e = this;
                                        if (this.props.responsive) {
                                            var t = this.props.responsive.map(function(e) {
                                                return e.breakpoint;
                                            });
                                            t.sort(function(e, t) {
                                                return e - t;
                                            }),
                                                t.forEach(function(n, r) {
                                                    var i;
                                                    (i =
                                                        0 === r
                                                            ? je()({ minWidth: 0, maxWidth: n })
                                                            : je()({ minWidth: t[r - 1] + 1, maxWidth: n })),
                                                        k() &&
                                                            e.media(i, function() {
                                                                e.setState({ breakpoint: n });
                                                            });
                                                });
                                            var n = je()({ minWidth: t.slice(-1)[0] });
                                            k() &&
                                                this.media(n, function() {
                                                    e.setState({ breakpoint: null });
                                                });
                                        }
                                    },
                                },
                                {
                                    key: 'componentWillUnmount',
                                    value: function() {
                                        this._responsiveMediaHandlers.forEach(function(e) {
                                            Ae.unregister(e.query, e.handler);
                                        });
                                    },
                                },
                                {
                                    key: 'render',
                                    value: function() {
                                        var e,
                                            t,
                                            n = this;
                                        (e = this.state.breakpoint
                                            ? 'unslick' ===
                                              (t = this.props.responsive.filter(function(e) {
                                                  return e.breakpoint === n.state.breakpoint;
                                              }))[0].settings
                                                ? 'unslick'
                                                : Ce({}, Pe, {}, this.props, {}, t[0].settings)
                                            : Ce({}, Pe, {}, this.props)).centerMode &&
                                            (e.slidesToScroll, (e.slidesToScroll = 1)),
                                            e.fade &&
                                                (e.slidesToShow,
                                                e.slidesToScroll,
                                                (e.slidesToShow = 1),
                                                (e.slidesToScroll = 1));
                                        var r = i.a.Children.toArray(this.props.children);
                                        (r = r.filter(function(e) {
                                            return 'string' == typeof e ? !!e.trim() : !!e;
                                        })),
                                            e.variableWidth &&
                                                (1 < e.rows || 1 < e.slidesPerRow) &&
                                                (console.warn(
                                                    'variableWidth is not supported in case of rows > 1 or slidesPerRow > 1',
                                                ),
                                                (e.variableWidth = !1));
                                        for (var o = [], s = null, a = 0; a < r.length; a += e.rows * e.slidesPerRow) {
                                            for (
                                                var l = [], c = a;
                                                c < a + e.rows * e.slidesPerRow;
                                                c += e.slidesPerRow
                                            ) {
                                                for (
                                                    var u = [], d = c;
                                                    d < c + e.slidesPerRow &&
                                                    (e.variableWidth &&
                                                        r[d].props.style &&
                                                        (s = r[d].props.style.width),
                                                    !(d >= r.length));
                                                    d += 1
                                                )
                                                    u.push(
                                                        i.a.cloneElement(r[d], {
                                                            key: 100 * a + 10 * c + d,
                                                            tabIndex: -1,
                                                            style: {
                                                                width: ''.concat(100 / e.slidesPerRow, '%'),
                                                                display: 'inline-block',
                                                            },
                                                        }),
                                                    );
                                                l.push(i.a.createElement('div', { key: 10 * a + c }, u));
                                            }
                                            e.variableWidth
                                                ? o.push(i.a.createElement('div', { key: a, style: { width: s } }, l))
                                                : o.push(i.a.createElement('div', { key: a }, l));
                                        }
                                        if ('unslick' !== e)
                                            return (
                                                o.length <= e.slidesToShow && (e.unslick = !0),
                                                i.a.createElement(
                                                    Ee,
                                                    Le({ style: this.props.style, ref: this.innerSliderRefHandler }, e),
                                                    o,
                                                )
                                            );
                                        var p = 'regular slider ' + (this.props.className || '');
                                        return i.a.createElement('div', { className: p }, o);
                                    },
                                },
                            ]),
                            e
                        );
                    })();
                t.default = Ie;
            },
        ]),
        (n.c = i),
        (n.d = function(e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
        }),
        (n.r = function(e) {
            'undefined' != typeof Symbol &&
                Symbol.toStringTag &&
                Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
                Object.defineProperty(e, '__esModule', { value: !0 });
        }),
        (n.t = function(e, t) {
            if ((1 & t && (e = n(e)), 8 & t)) return e;
            if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (
                (n.r(r),
                Object.defineProperty(r, 'default', { enumerable: !0, value: e }),
                2 & t && 'string' != typeof e)
            )
                for (var i in e)
                    n.d(
                        r,
                        i,
                        function(t) {
                            return e[t];
                        }.bind(null, i),
                    );
            return r;
        }),
        (n.n = function(e) {
            var t =
                e && e.__esModule
                    ? function() {
                          return e.default;
                      }
                    : function() {
                          return e;
                      };
            return n.d(t, 'a', t), t;
        }),
        (n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.p = ''),
        n((n.s = 13))
    );
    function n(e) {
        if (i[e]) return i[e].exports;
        var t = (i[e] = { i: e, l: !1, exports: {} });
        return r[e].call(t.exports, t, t.exports, n), (t.l = !0), t.exports;
    }
    var r, i;
});
//# sourceMappingURL=react-slick.min.js.map
